import * as React from 'react';
import { Global, css } from '@emotion/react';
import styled from '@emotion/styled';
import { lighten, transparentize, readableColor } from 'polished';
const globalCss = css `
  html {
    box-sizing: border-box;
    font-size: 14px;
  }

  * {
    box-sizing: inherit;
  }

  body {
    font-family: -apple-system, 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans',
      'Helvetica Neue', 'Icons16', sans-serif;
    color: #182026;
    margin: 0;
  }
  select {
    width: 100%;
    border-radius: 3px;
    border: 1px solid #b3b3b3;
    font-size: 1rem;
    padding: 0.5rem;
  }

  button,
  input[type='submit'] {
    font-size: 1rem;
    cursor: pointer;
  }

  .ant-row {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .ant-col:first-child {
    padding-left: 0 !important;
  }

  .ant-col:last-child {
    padding-right: 0 !important;
  }

  .ant-tabs-nav-wrap {
    z-index: 1;
    flex-grow: 0 !important;
  }

  .ant-switch {
    width: 120px;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    padding: 10px 16px;
  }
`;
export const GlobalStyles = () => React.createElement(Global, { styles: globalCss });
export const Title = styled.h1 `
  line-height: 1.28581;
  font-size: 2rem;
  font-weight: 600;
`;
export const Title2 = styled.h2 `
  line-height: 1.28581;
  font-size: ${(props) => (props.scale || 1) * 22}px;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 0;
  display: inline-block;
`;
export const Title3 = styled.h3 `
  line-height: 1.5;
  font-size: 1.5rem;
  font-weight: 400;
  margin: 20px 0;
`;
export const Title4 = styled.h4 `
  line-height: 1.4;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 4px 0;
`;
export const Page = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;

  display: flex;
  flex-flow: row nowrap;
`;
export const Row = styled.div `
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;
export const CenterRow = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
export const CenterRowMobileColumn = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  @media (max-width: 500px) {
    flex-direction: column;
  }
`;
export const Stretch = styled.div `
  flex: 1;
`;
export const Content = styled.div `
  margin: 20px 30px;
`;
export const Instructions = styled.p `
  font-size: 1rem;
  line-height: 1.25;
  margin: 5px 0;
`;
export const InstructionsSmall = styled.p `
  font-size: 0.75rem;
  line-height: 1.1;
  margin: 2px 0;
  word-break: break-all;

  color: #888;

  a {
    cursor: pointer;
    color: #888;
    text-decoration: underline;
  }
`;
export const Link = styled.a `
  text-decoration: none;
  color: #4a90e2;
  word-break: break-all;
`;
export const Success = styled.p `
  font-size: 1rem;
  font-weight: 600;
  color: ${(props) => props.theme.successColour};
`;
export const ErrorText = styled.p `
  font-size: 1rem;
  font-weight: 600;
  color: ${(props) => props.theme.dangerColour};
  margin: 0.5rem 0;
  word-break: break-word;
`;
export const Spacer = styled.div `
  margin: 25px 0;
`;
export const Fader = styled.div `
  border-top: ${(props) => (props.divider ? `1px dotted ${props.theme.primaryColour}` : '0')};
  padding-top: ${(props) => (props.divider ? '1.5rem' : '0')};
  opacity: ${(props) => (props.fade ? 0.75 : 1.0)};
`;
export const Form = styled.form `
  position: relative;
  width: 100%;
  visibility: ${(props) => (props.hidden ? 'hidden' : 'visible')};
`;
export const Input = styled.input `
  border-radius: 3px;
  border: 1px solid ${(props) => lighten(0.5, props.theme.primaryColour)};

  font-size: 1rem;
  padding: 0.5rem;
  width: 100%;

  &:focus {
    outline: none;
    box-shadow: 0 0 3px 1px ${(props) => transparentize(0.4, props.theme.activeColour)};
  }
`;
export const TextArea = styled.textarea `
  border-radius: 3px;
  border: 1px solid ${(props) => lighten(0.5, props.theme.primaryColour)};

  font-family: inherit;
  font-size: 1rem;
  padding: 0.5rem;
  width: 100%;

  &:focus {
    outline: none;
    box-shadow: 0 0 3px 1px ${(props) => transparentize(0.4, props.theme.activeColour)};
  }
`;
export const Button = styled.button `
  background-color: ${(props) => {
    if (props.danger)
        return props.theme.dangerColour;
    if (props.cancel)
        return '#ccc';
    return props.theme.activeColour;
}};
  color: ${(props) => readableColor(props.theme.activeColour)};
  border: 0;
  border-radius: 5px;
  display: block;
  margin: 0.75rem ${(props) => (props.center ? 'auto' : '0.5rem')};
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;

  &:focus {
    outline: none;
    box-shadow: 0 0 3px 1px ${(props) => transparentize(0.4, props.theme.activeColour)};
  }

  &[disabled] {
    background-color: #a0bdde;
    cursor: default;
  }
`;
export const IconButton = styled.button `
  color: ${(props) => {
    if (props.danger)
        return props.theme.dangerColour;
    if (props.cancel)
        return '#ccc';
    return props.theme.activeColour;
}};
  background-color: transparent;
  border: 0;
  border-radius: 5px;
  display: block;
  margin: 0.75rem ${(props) => (props.center ? 'auto' : '0.5rem')};
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;

  &:focus {
    outline: none;
    box-shadow: 0 0 3px 1px ${(props) => transparentize(0.4, props.theme.activeColour)};
  }

  &[disabled] {
    background-color: #a0bdde;
    cursor: default;
  }
`;
export const ButtonLooksLikeALink = styled.button `
  color: #4a90e2;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: ${(props) => (props.large ? '20px' : '16px')};
  font-weight: ${(props) => (props.strong ? '600' : '400')};

  &:hover {
    text-decoration: underline;
  }
  &:focus {
    outline-style: none;
  }
`;
export const InsetBox = styled.div `
  width: 95%;
  margin: 1rem auto;
  padding: 1rem 2rem;
  border-bottom: 1px dotted #aaa;
  @media (max-width: 500px) {
    width: 100%;
    margin: 1rem auto;
    padding: 0;
  }
`;
export const Icon = styled.img `
  height: ${(props) => props.size}px;
  margin-right: 10px;
  display: block;
`;
export const RootContainer = styled.div `
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: minmax(1rem, auto) minmax(1rem, auto) 1fr;
  padding: 0 0.5rem 0.5rem 0.5rem;
`;
//# sourceMappingURL=global.styles.js.map